import React from "react";
import Tooltip from "@mui/material/Tooltip";
import "./ReportCard.css";
import { Link } from "react-router-dom";

export const ReportCard = ({ data, base }) => {
  return (
    <div
      key={data._id}
      className="reportCard">
      <img
        src={data.icon}
        alt=""
      />
      <h5 className="reportCard__title">{data.label}</h5>
      <Tooltip
        title={data.description}
        arrow
        placement="top"
        slotProps={{
          tooltip: {
            sx: {
              maxWidth: 280,
              fontSize: "14px",
              fontWeight: 500,
              lineHeight: 1.5,
            },
          },
        }}
      >
        <h6 className="reportCard__description">
          {data.description}
        </h6>
      </Tooltip>
      <div>
        <Link to={base ? `${base}/${data.link}` : data.link}>
          <button className="contained__lgbtn">Show Report</button>
        </Link>
      </div>
    </div>
  );
};
